import { render, staticRenderFns } from "./CostBearersChecks.vue?vue&type=template&id=1cf2e644&"
import script from "./CostBearersChecks.vue?vue&type=script&lang=ts&"
export * from "./CostBearersChecks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports